/** @format */

import React, { useState, useEffect, useRef } from "react";

import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.js";
import "bootstrap-icons/font/bootstrap-icons.css";
import "../../css/ReportMobile.css";

import { Modal } from "bootstrap";

import * as funcAll from "../../util/funcAll";

/////////////   Redux  //////////////
import { saveDataLatLon } from "../store/MapPositionSlice";
import { useSelector, useDispatch } from "react-redux";
import SecureStorage from "react-secure-storage";

import Follow_up_TH from "../menu/Follow-up-oldTH";

const constants = require("file-configs/constants");

export default function FollowMobileTH(props) {
  const globalData = useSelector((state) => ({ ...state }));
  const dispatch = useDispatch();

  const [success, setSuccess] = useState(false);
  const [error_message_password, setErrorMessagePassword] = useState("");

  const [ticket_id, setTicketId] = useState("");
  const [password, setPassword] = useState("");
  const detailReport2 = sessionStorage.getItem("detailReport2");

  useEffect(() => {
    if (detailReport2) {
      setSuccess(true);
    } else {
    }
  }, [detailReport2]);

  const handleCheckPassword = () => {
    const dispatchAuthorize = () => {
      let authorize = {
        ticket_report: ticket_id,
        password_report: password,
      };
      SecureStorage.setItem("authorization", authorize);
    };
    dispatchAuthorize();

    funcAll.checkCasePassword(ticket_id, password).then((res) => {
      if (res["status"] === "success") {
        SecureStorage.setItem("detailReport", res["results"]);
        sessionStorage.setItem("detailReport2", JSON.stringify(res["results"]));
        setErrorMessagePassword("");
        setSuccess(true);
      } else {
        setSuccess(false);
        SecureStorage.setItem("detailReport", []);
        setErrorMessagePassword(
          "*Ticket ID หรือ รหัสผ่านไม่ถูกต้อง กรุณาตรวจสอบและกรอกใหม่อีกครั้ง"
        );
      }
    });
  };

  const sendReportData = async (e) => {
    e.preventDefault();
  };

  return (
    <>
      {success === true ? (
        <Follow_up_TH />
      ) : (
        <div className="container-in-tab-content">
          <form
            id="myform"
            class="needs-validation"
            novalidate
            onSubmit={sendReportData}>
            <div className="container-title pt-2">
              <p className="txt-th title">Ticket ID</p>
            </div>

            <input
              required
              type="text"
              className="form-control shadow-style input"
              value={ticket_id}
              onChange={(e) => setTicketId(e.target.value)}
              placeholder="กรอก Ticket ID เช่น  2023-ABCOP"
            />

            <div className="container-title pt-5">
              <p className="txt-th title">รหัสผ่าน</p>
            </div>

            <input
              required
              type="text"
              className="form-control shadow-style input"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="รหัสผ่านที่ได้รับ เมื่อแจ้งปัญหาเรียบร้อยแล้ว"
            />
            <div className="mt-3">
              <p className="err-message-txt">{error_message_password}</p>
            </div>

            <a
              className="btn-report my-5"
              onClick={handleCheckPassword}
              style={{ width: "60%" }}>
              <p>ติดตามความก้าวหน้า</p>
            </a>
          </form>
        </div>
      )}
    </>
  );
}
